// extracted by mini-css-extract-plugin
export var aboveInput = "_lu-0";
export var actionButton = "_lu-5";
export var actionButtonContainer = "_lu-1";
export var actionIcon = "_lu-6";
export var aiInfoContainer = "_lu-2";
export var attachmentWrapper = "_lu-7";
export var bold = "_lu-3";
export var checkIcon = "_lu-8";
export var clickingRecipientBar = "_lu-11";
export var commentThreadSwitch = "_lu-a";
export var draftImage = "_lu-b";
export var draftImageContainer = "_lu-c";
export var draftImages = "_lu-e";
export var editButton = "_lu-g";
export var editor = "_lu-f";
export var editorContainer = "_lu-y";
export var editorErrorTooltipWrapper = "_lu-9";
export var headerDivider = "_lu-h";
export var icon = "_lu-i";
export var info = "_lu-j";
export var internal = "_lu-n";
export var internalDivider = "_lu-k";
export var internalMessage = "_lu-l";
export var messageInputCard = "_lu-m";
export var messageInputForm = "_lu-o";
export var messageInputFormInternal = "_lu-p";
export var options = "_lu-q";
export var publicMessageCustomer = "_lu-s";
export var publicMessageMerchant = "_lu-r";
export var removeImageButton = "_lu-d";
export var replyButtons = "_lu-t";
export var showSignatureButton = "_lu-u";
export var spinner = "_lu-v";
export var verticalButtonDivider = "_lu-4";
export var visibilitySelector = "_lu-w";
export var warning = "_lu-x";
export var wrappingText = "_lu-z";
export var writingInternalNoteTopBorder = "_lu-10";